"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCartHeavy(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M9.727 18a1.727 1.727 0 110 3.455 1.727 1.727 0 010-3.455zm10 0a1.727 1.727 0 110 3.455 1.727 1.727 0 010-3.455zM5.217 2a2 2 0 011.897 1.364l.045.154.622 2.512h12.94a2 2 0 011.995 1.851l.006.15a2 2 0 01-.027.322l-.032.159-1.504 6.06a2 2 0 01-1.78 1.512l-.161.007H9.782a2 2 0 01-1.896-1.364l-.045-.154L5.218 4H3a1 1 0 01-.117-1.993L3 2h2.218zm3.061 6.03l1.504 6.06h9.436l1.504-6.06H8.278z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCartHeavy;
exports.default = _default;